import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
    selector: 'sp-base-grid-layout',
    templateUrl: './sp-base-grid-layout.component.html',
    styleUrls: ['./sp-base-grid-layout.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf],
})
export class SpBaseGridLayoutComponent {
    @Input() public disableElementsPanel: boolean = false;
    @Input() public disableControlsPanel: boolean = false;
}
